import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, Snackbar, Alert } from '@mui/material';
import CookieIcon from '@mui/icons-material/Cookie';
import PolicyIcon from '@mui/icons-material/Policy';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { CookieBanner } from '../../pages/login/components/CookieBanner'; // Adjust the import path if needed
import Divider from '@mui/material/Divider';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import LockResetIcon from '@mui/icons-material/LockReset';

export default function RightMenu({ anchorEl, open, onClose = () => { } }) {
  const navigate = useNavigate();
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [cookieConsent, setCookieConsent] = useState(null); // Store user's cookie settings
  const [showDevInfo, setShowDevInfo] = useState(false);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        onClose();
        navigate('/');
      })
      .catch((error) => {
        console.log(error);
        onClose();
      });
  };

  const handlePasswordReset = () => {
    onClose();
    navigate('/password-reset');
  }

  const handleConsentChange = (consent) => {
    setCookieConsent(consent);
    // Optionally, persist consent to localStorage or cookies:
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
  };

  const handleOpenCookies = () => {
    onClose(); // Close the menu first
    setTimeout(() => setShowCookieBanner(true), 150); // Open banner after menu closes
  };

  const handleCookieBannerClose = () => {
    setShowCookieBanner(false);
  };

  return (
    <>
      <Menu
        id="right-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleOpenCookies}>
          <ListItemIcon>
            <CookieIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Cookies</ListItemText>
        </MenuItem>
        <MenuItem
          component="a"
          href="https://daten.7776.link/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
        >
          <ListItemIcon>
            <PolicyIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Datenschutzerklärung</ListItemText>
        </MenuItem>

        <MenuItem onClick={handlePasswordReset}>
          <ListItemIcon>
            <LockResetIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Passwort ändern</ListItemText>
        </MenuItem>

        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
        <Divider sx={{ my: 1 }} />
        <MenuItem
          onClick={() => {
            setShowDevInfo(true);
            // Do not close the menu
          }}
        >
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Entwickler</ListItemText>
        </MenuItem>
        <MenuItem
          component="a"
          href="mailto:ollo7776@gmail.com"
          onClick={onClose}
        >
          <ListItemIcon>
            <MailOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Kontakt</ListItemText>
        </MenuItem>
        <MenuItem
          component="a"
          href="mailto:ollo7776@gmail.com?subject=Konto%20L%C3%B6schen%20Anfrage"
          onClick={onClose}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Konto löschen</ListItemText>
        </MenuItem>
      </Menu>
      {showDevInfo && (
        <>
          {/* Overlay to catch outside clicks */}
          <div
            onClick={() => setShowDevInfo(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              zIndex: 1999,
              background: 'transparent',
            }}
          />
          <div
            style={{
              position: 'fixed',
              top: 10,
              right: 10,
              zIndex: 2000,
              minWidth: 320,
              maxWidth: 400,
            }}
          >
            <Alert
              severity="info"
              sx={{ width: '90%' }}
              onClose={() => setShowDevInfo(false)}
            >
              <strong>Entwickler:</strong> Aleksander Ligeza-Salamon<br />
              Die Anwendung wurde für Mitarbeiter der Deutschen Bank in Frankfurt-Höchst entwickelt, um unsere Arbeit zu vereinfachen und die Qualität zu verbessern.<br />
              Wenn Sie Ideen oder Tipps haben, was noch nützlich sein könnte oder was geändert werden sollte, kontaktieren Sie mich bitte.
            </Alert>
          </div>
        </>
      )}
      {showCookieBanner && (
        <CookieBanner
          open={showCookieBanner}
          onClose={handleCookieBannerClose}
          onConsentChange={handleConsentChange}
          forceShow={true}
        />
      )}
    </>
  );
}